import React from "react"
import PropTypes from "prop-types"
import momentPropTypes from "react-moment-proptypes"
import moment from "moment"
import "./ActivityTimeline.scss"

const TimelineContext = React.createContext({})

class ActivityTimeline extends React.PureComponent {
  markerRenderer = time => {
    return (
      <div className="marker" key={time.toISOString()}>
        {(this.props.markerRenderer &&
          this.props.markerRenderer(
            time,
            this.props.startAt,
            this.props.endAt
          )) || <div className="marker-default" />}
        {this.markerLabelRenderer(time)}
      </div>
    )
  }

  markerLabelRenderer = time => {
    return (
      <div className="marker-label">
        {(this.props.markerLabelRenderer &&
          this.props.markerLabelRenderer(
            time,
            this.props.startAt,
            this.props.endAt
          )) || (
          <div className="marker-label-default">{time.toISOString()}</div>
        )}
      </div>
    )
  }

  render() {
    const markers = []
    for (
      let curTime = moment(this.props.startAt);
      curTime <= this.props.endAt;
      curTime.add(this.props.markerInterval)
    ) {
      markers.push(curTime.clone())
    }

    return (
      <div className="ActivityTimeline">
        <TimelineContext.Provider
          value={{
            startAt: this.props.startAt,
            endAt: this.props.endAt,
          }}
        >
          <div className="markers">
            {markers.map(m => this.markerRenderer(m))}
          </div>
          <div className="events">{this.props.children}</div>
        </TimelineContext.Provider>
      </div>
    )
  }
}

ActivityTimeline.propTypes = {
  // Beginning of the timeline.
  startAt: momentPropTypes.momentObj.isRequired,
  // End of the timeline.
  endAt: momentPropTypes.momentObj.isRequired,
  // The amount of time between each marker placement. Moment duration: https://momentjs.com/docs/#/durations/
  markerInterval: momentPropTypes.momentDurationObj.isRequired,
  // Return a node to render as a point in time marker.
  markerRenderer: PropTypes.func,
  // Return a node to render as a label for each point in time marker.
  markerLabelRenderer: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.node,
  ]),
}

export { ActivityTimeline as default, TimelineContext }
